import { isEmptyOrUndefined } from "../filter-value";
import {
	DECLARATION_QUESTION_KEYS,
	BANKRUPTCY_CHAPTER_KEYS,
	MILITARY_CHECKBOX_KEYS,
	VISUAL_OBSERVATION_KEYS,
	ETHNICITY_KEYS,
	RACE_KEYS,
	SEX_KEYS,
} from "../current-loan-encompass-mappers";

// Mirrors the Add New Loan Step 6 rules, per person:
//   validateDeclarationInformation · validateMilitaryInformation ·
//   validateDemographicProvided · validateDemographicInformation
// (src/utils/required-field-helper/*). The co-borrower is only validated when a
// co-borrower exists (first name entered), same as the wizard.

const REQUIRED_MESSAGE =
	"Please provide a value for all fields highlighted above.";

const unanswered = (v) => v === null || v === undefined || v === "";

const collectPersonErrors = (decl, prefix, errors) => {
	const d = decl || {};
	const add = (key) => errors.add(`${prefix}.${key}`);

	// Declarations A–M
	DECLARATION_QUESTION_KEYS.forEach((key) => {
		if (unanswered(d[key])) add(key);
	});
	if (d.intentToOccupyIndicator === true) {
		if (unanswered(d.homeownerPastThreeYearsIndicator)) add("homeownerPastThreeYearsIndicator");
		if (d.homeownerPastThreeYearsIndicator === true) {
			if (isEmptyOrUndefined(d.priorPropertyUsageType)) add("priorPropertyUsageType");
			if (isEmptyOrUndefined(d.priorPropertyTitleType)) add("priorPropertyTitleType");
		}
	}
	if (
		d.undisclosedBorrowedFundsIndicator === true &&
		isEmptyOrUndefined(d.undisclosedBorrowedFundsAmount)
	) {
		add("undisclosedBorrowedFundsAmount");
	}
	if (d.bankruptcyIndicator === true && !BANKRUPTCY_CHAPTER_KEYS.some((k) => d[k] === true)) {
		add("bankruptcyChapters");
	}

	// Military — the expected completion date is optional, as in the wizard.
	if (unanswered(d.selfDeclaredMilitaryServiceIndicator)) {
		add("selfDeclaredMilitaryServiceIndicator");
	} else if (
		d.selfDeclaredMilitaryServiceIndicator === true &&
		!MILITARY_CHECKBOX_KEYS.some((k) => d[k] === true)
	) {
		add("militaryService");
	}

	// Demographic information provided through — all 3 visual answers always required.
	if (isEmptyOrUndefined(d.applicationTakenMethodType)) add("applicationTakenMethodType");
	VISUAL_OBSERVATION_KEYS.forEach((key) => {
		if (isEmptyOrUndefined(d[key])) add(key);
	});

	// Demographic information: at least one ethnicity, race and sex.
	if (!ETHNICITY_KEYS.some((k) => d[k] === true)) add("ethnicity");
	if (!RACE_KEYS.some((k) => d[k] === true)) add("race");
	if (!SEX_KEYS.some((k) => d[k] === true)) add("sex");
};

// data = { bDecl, cbDecl, hasCoBorrower }
export const getDashboardDeclarationsFieldErrors = (data) => {
	const errors = new Set();
	const { bDecl, cbDecl, hasCoBorrower } = data || {};
	collectPersonErrors(bDecl, "bDecl", errors);
	if (hasCoBorrower) collectPersonErrors(cbDecl, "cbDecl", errors);
	return errors;
};

export const validateDashboardDeclarations = (data, setError) => {
	const errors = getDashboardDeclarationsFieldErrors(data);
	if (errors.size > 0) {
		setError(REQUIRED_MESSAGE);
		return false;
	}
	return true;
};
